export const HTTP_METHODS_VALUES = {
    GET: 'GET',
    POST: 'POST',
    PUT: 'PUT',
    PATCH: 'PATCH',
    DELETE: 'DELETE',
};

export type HTTP_METHODS = keyof typeof HTTP_METHODS_VALUES;